// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"PageLoader_loader-wrapper__jVsSX","loader-inner":"PageLoader_loader-inner__ahLhX","animationLoader":"PageLoader_animationLoader__HyntA"};